import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { UsageGuide } from "../../productUsageGuides.types";
import { requestDeleteUsageGuideFaqItem } from "./deleteUsageGuideFaqItem.request";

const useDeleteUsageGuideFaqItem = (
  options?: MutationOptions<UsageGuide, ApiServiceError<ApiError>, string>
) => {
  const refetchUsageGuides = useRefetchQuery(["product-usage-guides"]);

  return useMutation({
    mutationFn: requestDeleteUsageGuideFaqItem,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchUsageGuides();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useDeleteUsageGuideFaqItem;
